import { createContext, useContext, useMemo } from 'react';
import { ServerURLs } from '../data/serverUrls.ts';

export type AppConfig = {
    urls: ServerURLs;
    loginId: string;
    locale: string;
    brand: string;
    overrideTitle: string;
};

const AppConfigContext = createContext<AppConfig | undefined>(void 0);

type AppConfigProviderProps = AppConfig & {
    children: React.ReactNode;
};

export function AppConfigProvider(props: AppConfigProviderProps) {
    const { children, ...config } = props;
    const value = useMemo<AppConfig>(() => config, [config]);
    return <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>;
}

export function useAppConfig() {
    const context = useContext(AppConfigContext);
    if (context === undefined) {
        throw new Error('useAppConfig must be used within an AppConfigProvider');
    }
    return context;
}
